import { useId } from "../lib/uid.ts";

/** As the other icons (outlined: Tabler's size and stroke). */
const SIZE = 16;
const STROKE = 1.75;

/** `skew-y`'s trapezoid. */
const OUTLINE =
  "M4.326 19h15.348a1 1 0 0 0 .962 -1.275l-3.429 -12a1 1 0 0 0 -.961 -.725h-8.492a1 1 0 0 0 -.961 .725l-3.429 12a1 1 0 0 0 .962 1.275";

/** The triage area (Tabler has none): `skew-y`'s trapezoid, dotted (20 dots, evenly round it), hatched like
 * `background`, evenly (set so the corners' hatches come out alike, none a stub). The hatches run past the outline
 * and are cut along it: their own ends, round or square, would stick out where they meet it at a slant. */
export function TriageIcon({ class: cls, size = SIZE }: { class?: string; size?: number }) {
  const clip = useId();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width={STROKE}
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
      class={`shrink-0 ${cls ?? ""}`}
    >
      <clipPath id={clip}>
        <path d={OUTLINE} />
      </clipPath>
      <path clip-path={`url(#${clip})`} d="M3.22 13.22L13.44 3M3.22 21L19.49 4.73M11 21L21.22 10.78" />
      <path d={OUTLINE} pathLength={20} stroke-dasharray="0 1" />
    </svg>
  );
}
